import {IColumnExtended, IMILLQualityData, MSQualityData} from "./types";
import {formatDate, formatDateTimeWithSeconds} from "../../../system/utils";


const roundToDigits = (value: number, digits: number): number => {
  const factor = Math.pow(10, digits);

  return Math.round(value * factor) / factor;
}

const numberAccessor = (value: number | null | undefined, fixed = 0): string | number => {

  return Number.isFinite(value) ? roundToDigits(value as number, fixed) : "";
}

const Columns:  IColumnExtended[] = [
  {
    id: "microStructure",
    label: "MicroStructure",
    labelA: null,
    labelB: null,
    minWidth: 0,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, _strandIndex?: number) => millData?.qmos?.microstructure || ""
  },
  {
    id: "heatNumber",
    label: "Heat number",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    accessor:  (caster: MSQualityData | null) => caster?.heatNumber ?? "---"
  },
  {
    id: "steelGrade",
    label: "Grade",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    accessor: (caster: MSQualityData | null) => caster?.code ?? "---"
  },
  {
    id: "castingDate",
    label: "Casting Date",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    accessor: (caster: MSQualityData | null, _millData?: IMILLQualityData, _strandIndex?: number, raw?: true) => {

      if (raw) {
        if (!caster || !caster.factoryDay)  {

          return null;
        }

        return  caster ? formatDate(caster?.factoryDay) : "";
      }

      return  caster ? formatDate(caster?.factoryDay) : "";
    }
  },
  {
    id: "startCasting",
    label: "Start Casting",
    labelA: null,
    labelB: null,
    minWidth: 180,
    mainRow: true,
    accessor: (caster: MSQualityData | null,  _millData?: IMILLQualityData, _strandIndex?: number, raw?: true) => {

      if (raw) {

        return caster ? formatDateTimeWithSeconds(caster?.beginDatetime) : "";
        //return caster && caster.beginDatetime ? DateTime.fromSeconds(caster.beginDatetime).toJSDate() : null;
      }

      return caster ? formatDateTimeWithSeconds(caster?.beginDatetime) : "";
    }
  },
  {
    id: "superHeatMin",
    label: "Min",
    subLabel: "[°F]",
    labelA:  { label: "Super Heat", span: 2 },
    labelB: null,
    minWidth: 100,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.superHeat?.min)
  },
  {
    id: "superHeatMax",
    label: "Max",
    subLabel: "[°F]",
    labelA:  null,
    labelB: null,
    minWidth: 100,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.superHeat?.max)
  },
  {
    id: "tundishSequence",
    label: "Tun. Sq.",
    subLabel: "[#]",
    labelA: null,
    labelB: null,
    minWidth: 110,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.heatSeq)
  },
  {
    id: "tundishWeight",
    label: "Tun. W. Avg",
    subLabel: "[sTon]",
    labelA: null,
    labelB: null,
    minWidth: 140,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.tundishWeight)
  },
  {
    id: "castingSpeed1Min",
    label: "Min",
    subLabel: "[ipm]",
    labelA: { label: "Strand 1", span: 2, alternateBg: true },
    labelB: { label: "Casting speed", span: 10, alternateBg: true },
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand1.min)
  },
  {
    id: "castingSpeed1Max",
    label: "Max",
    subLabel: "[ipm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) =>  numberAccessor(caster?.speed.strand1.max)
  },
  {
    id: "castingSpeed2Min",
    label: "Min",
    subLabel: "[ipm]",
    labelA: { label: "Strand 2", span: 2 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand2.min)
  },
  {
    id: "castingSpeed2Max",
    label: "Max",
    subLabel: "[ipm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand2.max)
  },
  {
    id: "castingSpeed3Min",
    label: "Min",
    subLabel: "[ipm]",
    labelA: { label: "Strand 3", span: 2, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand3.min)
  },
  {
    id: "castingSpeed3Max",
    label: "Max",
    subLabel: "[ipm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand3.max)
  },
  {
    id: "castingSpeed4Min",
    label: "Min",
    subLabel: "[ipm]",
    labelA: { label: "Strand 4", span: 2 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand4.min)
  },
  {
    id: "castingSpeed4Max",
    label: "Max",
    subLabel: "[ipm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand4.max)
  },
  {
    id: "castingSpeed5Min",
    label: "Min",
    subLabel: "[ipm]",
    labelA: { label: "Strand 5", span: 2, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand5.min)
  },
  {
    id: "castingSpeed5Max",
    label: "Max",
    subLabel: "[ipm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.speed.strand5.max)
  },
  {
    id: "secondaryCoolingS1Z1",
    label: "Z1 Avg",
    subLabel: "[gpm]",
    labelA: { label: "Strand 1", span: 4 },
    labelB: { label: "Secondary Cooling / Flow", span: 20 },
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand1.z1)
  },
  {
    id: "secondaryCoolingS1Z2",
    label: "Z2 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand1.z2)
  },
  {
    id: "secondaryCoolingS1Z3",
    label: "Z3 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand1.z3)
  },  {
    id: "secondaryCoolingS1Z4",
    label: "Z4 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand1.z4)
  },
  {
    id: "secondaryCoolingS2Z1",
    label: "Z1 Avg",
    subLabel: "[gpm]",
    labelA: { label: "Strand 2", span: 4, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand2.z1)
  },
  {
    id: "secondaryCoolingS2Z2",
    label: "Z2 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand2.z2)
  },
  {
    id: "secondaryCoolingS2Z3",
    label: "Z3 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand2.z3)
  },  {
    id: "secondaryCoolingS2Z4",
    label: "Z4 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand2.z4)
  },
  {
    id: "secondaryCoolingS3Z1",
    label: "Z1 Avg",
    subLabel: "[gpm]",
    labelA: { label: "Strand 3", span: 4 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand3.z1)
  },
  {
    id: "secondaryCoolingS3Z2",
    label: "Z2 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand3.z2)
  },
  {
    id: "secondaryCoolingS3Z3",
    label: "Z3 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand3.z3)
  },  {
    id: "secondaryCoolingS3Z4",
    label: "Z4 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand3.z4)
  },
  {
    id: "secondaryCoolingS4Z1",
    label: "Z1 Avg",
    subLabel: "[gpm]",
    labelA: { label: "Strand 4", span: 4, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand4.z1)
  },
  {
    id: "secondaryCoolingS4Z2",
    label: "Z2 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand4.z2)
  },
  {
    id: "secondaryCoolingS4Z3",
    label: "Z3 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand4.z3)
  },  {
    id: "secondaryCoolingS4Z4",
    label: "Z4 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand4.z4)
  },
  {
    id: "secondaryCoolingS5Z1",
    label: "Z1 Avg",
    subLabel: "[gpm]",
    labelA: { label: "Strand 5", span: 4 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand5.z1)
  },
  {
    id: "secondaryCoolingS5Z2",
    label: "Z2 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand5.z2)
  },
  {
    id: "secondaryCoolingS5Z3",
    label: "Z3 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand5.z3)
  },  {
    id: "secondaryCoolingS5Z4",
    label: "Z4 Avg",
    subLabel: "[gpm]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.secondaryCooling.strand5.z4)
  },
  {
    id: "stirring1",
    label: "Avg",
    subLabel: "[A]",
    labelA: { label: "Strand 1", span: 1, alternateBg: true },
    labelB: { label: "Mould Stirring", span: 5, alternateBg: true },
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.stirring.strand1)
  },
  {
    id: "stirring2",
    label: "Avg",
    subLabel: "[A]",
    labelA: { label: "Strand 2", span: 1 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.stirring.strand2)
  },
  {
    id: "stirring3",
    label: "Avg",
    subLabel: "[A]",
    labelA: { label: "Strand 3", span: 1, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.stirring.strand3)
  },
  {
    id: "stirring4",
    label: "Avg",
    subLabel: "[A]",
    labelA: { label: "Strand 4", span: 1 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.stirring.strand4)
  },
  {
    id: "stirring5",
    label: "Avg",
    subLabel: "[A]",
    labelA: { label: "Strand 5", span: 1, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.stirring.strand5)
  },
  {
    id: "mouldLevel1",
    label: "Avg",
    subLabel: "[%]",
    labelA: { label: "Strand 1", span: 1 },
    labelB: { label: "Mould Level", span: 5 },
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.mouldLevel.strand1)
  },
  {
    id: "mouldLevel2",
    label: "Avg",
    subLabel: "[%]",
    labelA: { label: "Strand 2", span: 1, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.mouldLevel.strand2)
  },
  {
    id: "mouldLevel3",
    label: "Avg",
    subLabel: "[%]",
    labelA: { label: "Strand 3", span: 1 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.mouldLevel.strand3)
  },
  {
    id: "mouldLevel4",
    label: "Avg",
    subLabel: "[%]",
    labelA: { label: "Strand 4", span: 1, alternateBg: true },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.mouldLevel.strand4)
  },
  {
    id: "mouldLevel5",
    label: "Avg",
    subLabel: "[%]",
    labelA: { label: "Strand 5", span: 1 },
    labelB: null,
    minWidth: 120,
    align: "right",
    mainRow: true,
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.mouldLevel.strand5)
  },
  {
    id: "coolingBed",
    label: "Cycle Time",
    subLabel: "[s]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (caster: MSQualityData | null) => numberAccessor(caster?.coolingBedCycle)
  },
  {
    id: "chemistryC",
    label: "C",
    subLabel: "[%]",
    labelA: { label: "Chemistry, residuals", span: 17 },
    labelB: { label: "", span: 17 },
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.c, 4)
  },
  {
    id: "chemistryMn",
    label: "P",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.mn, 4)
  },
  {
    id: "chemistryP",
    label: "%",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.p, 4)
  },
  {
    id: "chemistryS",
    label: "S",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.s, 4)
  },
  {
    id: "chemistrySi",
    label: "Si",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.si, 4)
  },
  {
    id: "chemistryCu",
    label: "Cu",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.cu, 4)
  },
  {
    id: "chemistryNi",
    label: "Ni",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.ni, 4)
  },
  {
    id: "chemistryCr",
    label: "Cr",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.cr, 4)
  },

  {
    id: "chemistryMo",
    label: "Mo",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.mo, 4)
  },
  {
    id: "chemistrySn",
    label: "Sn",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.sn, 4)
  },
  {
    id: "chemistryV",
    label: "V",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.v, 4)
  },
  {
    id: "chemistryCb",
    label: "Cb",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.cb, 4)
  },
  {
    id: "chemistryAl",
    label: "Al",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.al, 4)
  },
  {
    id: "chemistryB",
    label: "B",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.b, 4)
  },
  {
    id: "chemistryN",
    label: "N",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.n, 4)
  },
  {
    id: "chemistryBn",
    label: "B/N",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.b_n, 4)
  },
  {
    id: "chemistryPb",
    label: "Pb",
    subLabel: "[%]",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.chemistry.pb, 4)
  },
  {
    id: "notes",
    label: "Notes",
    labelA: null,
    labelB: null,
    minWidth: 120,
    mainRow: true,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.qmos?.size || ""
  },
  {
    id: "strand",
    label: "Strand",
    labelA: null,
    labelB: null,
    minWidth: 120,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.strands[strandIndex ?? 0]?.machineName || ""
  },
  {
    id: "millHeat",
    label: "Mill Heat",
    labelA: null,
    labelB: null,
    minWidth: 120,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.strands[strandIndex ?? 0]?.millHeat || ""
  },
  {
    id: "meltHeat",
    label: "Melt Heat",
    labelA: null,
    labelB: null,
    minWidth: 120,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.strands[strandIndex ?? 0]?.meltHeat || ""
  },
  {
    id: "millGrade",
    label: "Mill Grade",
    labelA: null,
    labelB: null,
    minWidth: 180,
    align: "center",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.strands[strandIndex ?? 0]?.meltGrade || ""
  },
  {
    id: "size",
    label: "Size",
    labelA: null,
    labelB: null,
    minWidth: 0,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.qmos?.size || ""
  },
  {
    id: "rollingDate",
    label: "Rolling Date",
    labelA: null,
    labelB: null,
    minWidth: 200,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.qmos?.rollingDate || ""
  },
  {
    id: "coilCount",
    label: "Coil Count",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.totalBillets)
  },
  {
    id: "fmSpeed",
    label: "FM Speed",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: () => ""
  },
  {
    id: "rs",
    label: "RS",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: () => ""
  },
  {
    id: "speed",
    label: "Speed",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: () => ""
  },
  {
    id: "lht",
    label: "LHT",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.lhTemp, 2)
  },

  {
    id: "temperature",
    label: "Temperature",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: () => ""
  },
  {
    id: "1a",
    label: "1A",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed1A, 2)
  },
  {
    id: "1b",
    label: "1B",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed1B, 2)
  },
  {
    id: "2a",
    label: "2A",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed2A, 2)
  },
  {
    id: "2b",
    label: "2B",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed2B, 2)
  },
  {
    id: "3a",
    label: "3A",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed3A, 2)
  },
  {
    id: "3b",
    label: "3B",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed3B, 2)
  },
  {
    id: "4a",
    label: "4A",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed4A, 2)
  },
  {
    id: "4b",
    label: "4B",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed4B, 2)
  },
  {
    id: "5A",
    label: "5A",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.strands[strandIndex ?? 0]?.speed5A, 2)
  },

  {
    id: "taggedTons",
    label: "Tagged Tons",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.taggedTons)
  },
  {
    id: "tensile",
    label: "Tensile",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.tensile)
  },
  {
    id: "eTensile_Calc",
    label: "eTensile Calc",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.eTensile_Calc)
  },
  {
    id: "eTensile_Calc_Min",
    label: "eTensile Calc Min",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.eTensile_Calc_Min)
  },
  {
    id: "eTensile_Calc_Max",
    label: "eTensile Calc Max",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.eTensile_Calc_Max)
  },
  {
    id: "roa",
    label: "ROA",
    labelA: null,
    labelB: null,
    minWidth: 120,
    align: "right",
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => numberAccessor(millData?.qmos?.roa)
  },
  {
    id: "disposition",
    label: "Disposition",
    labelA: null,
    labelB: null,
    minWidth: 200,
    accessor: (_caster: MSQualityData | null, millData?: IMILLQualityData, strandIndex?: number) => millData?.qmos?.disposition || ""
  }
];

export default Columns;